import styled from '@emotion/styled';
import { borderColor } from '../TableRowContainer/TableRowContainer.styled';
import { TableHeaderProps, StyledProps } from './TableHeadDataContainer.types';

const TableHeader = styled.th<StyledProps & TableHeaderProps>`
  padding: ${(props) => (props.headingRowsPadding ? props.headingRowsPadding : '20px')};
  text-align: ${(props) => (props.centered ? 'center' : 'start')};
  border-left-width: ${(props) => (props.value ? '1px' : '0px')};
  border-left-style: solid;
  border-left-color: ${borderColor};
  font-size: var(--text-md);

  @media (max-width: 1460px) {
    padding: 13px;
  }

  @media (max-width: 1200px) {
    padding: 7px;
  }
`;

export default TableHeader;
